import React from 'react';
import { connect } from 'react-redux';
import EmailSignUp from './EmailSignUp'
import EmailLogin from './EmailLogin'
// import { Icon } from 'react-fa'
import { Link } from "react-router-dom";

const SignUpBaseNode = props => {

  const { id, number, client, x, y } = props
  return(
    <div>
      <div className='node child'
        style={{
          transform: `translate3d(
            ${x || client.x[number]}px,
            ${y || client.y[number]}px,
            0px)`, zIndex:`1`, color: `#5D5D5D`}}>
            { (() => {
              switch(id) {
                case 'sign_up.facebook':
                case 'login.facebook':
                  return (
                    <div className='content'>
                      <div className='social'>
                        <Link to="users/facebook">
                          <p> Facebook </p>
                          <i class="fab fa-facebook-square fa-5x"></i>
                        </Link>
                      </div>
                    </div>
                  )
                case 'sign_up.twitter':
                case 'login.twitter':
                  return (
                    <div className='content'>
                      <div className='social'>
                        <Link to="users/twitter">
                          <p> Twitter </p>
                          <i class="fab fa-twitter-square fa-5x" />
                        </Link>
                      </div>
                    </div>
                  )
                case "sign_up.email":
                  return <EmailSignUp />
                case "login.email":
                  return <EmailLogin />
                default:
                  return null
              }
            })()}
          </div>
        </div>
  )
}

const mapStateToProps = state => ({
  client: state.client
});

export default connect(mapStateToProps)(SignUpBaseNode);



// WEBPACK FOOTER //
// ./src/components/SignupLogin/SignUpBaseNode.js